import React, { useEffect, useState } from 'react';
import { isValidNumber  } from '../../utils/utilities';
import './donut-chart.style.scss';
import { Pie } from '@ant-design/plots';

const DonutChartComponent = (props) => {

    const {
      AdminBlocked,
      Blocked,
      Booked,
      Vacant,
      Shared,
      isMobile
    }=props;
    let data=[] , color=[];

    const [centerTitle , setCenteredTitle] = useState(Vacant);
    const [centerContent , setCenteredContent] = useState("Seats");

    useEffect(()=>{
      setCenteredTitle(Vacant);
    },[Vacant]);

    if(isValidNumber(AdminBlocked)&&AdminBlocked>0){
      data.push({
        type: 'Admin Blocked',
        value: AdminBlocked,
        // angleField: "Admin Blocked("+AdminBlocked+")",
        "Admin Blocked": AdminBlocked
      })
      color.push('#479FF8');
    }
    if(isValidNumber(Booked)&&Booked>0){
      data.push({
        type: 'Booked',
        value: Booked,
        // angleField: "Booked("+Booked+")",
        "Booked": Booked
      })
      color.push('#81D653');
    }
    if(isValidNumber(Blocked)&&Blocked>0){
      data.push({
        type: 'Blocked',
        value: Blocked,
        // angleField: "Blocked("+Blocked+")",
        "Blocked": Blocked
      })
      color.push('#EFBD40');
    }
    if(isValidNumber(Vacant)&&Vacant>0){
      data.push({
        type: 'Vacant',
        value: Vacant,
        // angleField: "Vacant("+Vacant+")",  
        "Vacant": Vacant
      })
      color.push('#EA4025');
    }
    
    return (
        <div style={{marginTop: isMobile ? -10 : -20, position: 'relative', width: 135}}>
            <Pie
                label={{
                  visible:true,
                  autoRotate:true,
                  formatter:(value)=>{
                    return value.angleField
                  },
                  style:{
                    fontSize: 8, fill: 'black',
                    cursor: "pointer"
                  }
                }}
                data={data}
                color={color}
                height={90}
                width={135}
                legend={{
                    visible:false
                }}
                title={{
                    visible: false,
                    text: '环图',
                }}
                description={{
                    visible: false,
                    text: '环图的外半径决定环图的大小，而内半径决定环图的厚度。',
                }}
                radius={0.9}
                innerRadius ={0.55}
                padding='auto'
                angleField='value'
                colorField='type'
                tooltip={{
                  visible:true,
                  domStyles:{
                    'g2-tooltip':{width:'auto',minWidth:'140px',whiteSpace:'nowrap'},
                    'g2-tooltip-list-item':{whiteSpace:'nowrap'},
                    'g2-tooltip-value':{float:'none',marginLeft:'8px',display:'inline'}
                  },
                  formatter	:(info)=>{
                    const total = data.reduce((sum, item) => sum + item.value, 0);
                    const percentage = total > 0 ? Math.round((info.value / total) * 100) : 0;
                    return {name:info.type,value:`${info.value} <b>(${percentage}%)</b>`};
                  }
                }}
                autoFit
                statistic={{
                    title:{
                      customHtml:()=>{
                        return `${centerTitle}`
                      },
                      style:{fontSize: 18, fill: 'red',fontWeight:'bold'}
                    },
                    content:{
                      customHtml:()=>{
                        return centerContent
                      },
                      style:{fontSize: 10, fill: 'red',fontWeight:'bold'}
                    }
                }}
                events={{
                      // onRingClick: (event) => console.log(event),
                      // onLegendClick: (event) => console.log(event),
                      onPlotClick: (event) => {
                        // if(isValidArray(event.data)&&isValidArray(event.data.data)&&isValid(event.data.data.value)){
                        //   setCenteredTitle(event.data.data.value);
                        // }
                      }
                  }}
                />
                {isValidNumber(Shared)&&Shared>0&&
                    <div className="shared-seats-pill">{Shared} shared</div>
                }
        </div>
    );
}

function arePropsEqual(prevProps, nextProps) {
  return (
      prevProps.AdminBlocked === nextProps.AdminBlocked &&
      prevProps.Blocked === nextProps.Blocked &&
      prevProps.Booked === nextProps.Booked &&
      prevProps.Vacant === nextProps.Vacant &&
      prevProps.Shared === nextProps.Shared
    );
}

export default React.memo(DonutChartComponent,arePropsEqual);
